export enum DashboardPermissions {
  VIEW_DASHBOARD = "view_dashboard",
}

export const DashboardPermissionsText: Record<DashboardPermissions, string> = {
  [DashboardPermissions.VIEW_DASHBOARD]: "View Dashboard",
};
